import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useMsal } from '@azure/msal-react';
import { SortHelper } from '../../SortHelper';
import { Article, dataActionCreators, DataState } from '../../store/Data';
import { TeamsState } from '../../store/TeamsState';
import { Button, InputOnChangeData, SearchBox, SearchBoxChangeEvent, Text } from '@fluentui/react-components';
import { useEditorStyles, useTabStyles } from '../Styles/Editor';
import { useTranslation } from 'react-i18next';

export const ProductsTab = () => {
    const data = useSelector<ApplicationState, DataState>((state: ApplicationState) => state.data);
    const [filter, setFilter] = React.useState<string | null>(null);
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const { t } = useTranslation();
    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);
    const stylesTab = useTabStyles();
    const styles = useEditorStyles();

    React.useEffect(() => {
        if (data.products === undefined && data.productsLoading === false) {
            dispatch(dataActionCreators.requestProducts(instance, teamsState));
        }
        if (data.articles === undefined && data.articlesLoading === false) {
            dispatch(dataActionCreators.requestArticles(instance, teamsState));
        }
    }, [data]);

    if (data.products === undefined || data.productsLoading || data.articles === undefined || data.articlesLoading) {
        return (null);
    }

    //    {TenantHelper.ExpiredLicenses(t) && (<Label color="yellow" content="Expired License(s)" styles={{ marginLeft: "10px" }} />)}
    if (data.products.length !== 0 && data.articles) {
        const prod = filter && filter.length != 0
            ? data.products.filter(t => (t.displayName && t.displayName.toLowerCase().includes(filter.toLowerCase())))
            : data.products;

        return (
            <div className={stylesTab.rootSub}>
                <div className={stylesTab.MainBar}>
                    <SearchBox
                        placeholder={t('Contains')}
                        onChange={(e: SearchBoxChangeEvent, data: InputOnChangeData) => { setFilter(data.value); }}
                        dismiss={{ onClick: () => { setFilter(null); } }}
                        className={styles.fluid}
                    />
                </div>
                <h2>Products</h2>
                {prod.sort(SortHelper.productByName)
                    .map((t) => {
                        const itemsArticles: JSX.Element[] = [];
                        const arts: Article[] = data.articles ? data.articles.filter(x => x.productid === t.productid && x.isActif) : [];
                        if (arts.length > 0) {
                            arts.sort(SortHelper.articleByName).forEach((a) => {
                                itemsArticles.push(<Text>{a.displayName}</Text>);
                                itemsArticles.push(<Text>{a.unitPrice.toLocaleString(undefined, { style: 'currency', currency: 'EUR' }) + "/unit"}</Text>);
                            });
                        }
                        else {
                            itemsArticles.push(<Text>{"-"}</Text>);
                            itemsArticles.push(<Text>{"-"}</Text>);
                        }
                        return (<div className={stylesTab.segment}>
                            <Button appearance="transparent" className={stylesTab.TestButton} onClick={() => dispatch(dataActionCreators.requestProductQuickView(t))}>
                                {t.displayName}
                            </Button>
                            <div className={stylesTab.ProductGrid }>{itemsArticles}</div>
                        </div>);
                    })
                }
            </div>
        );
    }
    return null;
};